import { useContext } from 'react';

import PreviewLayoutContext from '../contexts/PreviewLayoutContext';

const usePreviewLayout = () => {
  const previewLayout = useContext(PreviewLayoutContext);

  if (!previewLayout) {
    throw new Error('usePreviewLayout hook needs to be used inside PreviewLayoutContext.Provider');
  }

  return previewLayout;
};

export default usePreviewLayout;
